export default __webpack_public_path__ + "static/media/Badge and Door Access.bb95afc5.svg";